import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import Multiselect from 'vue-multiselect'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import store from './store'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.component('multiselect', Multiselect)

import globalMixin from '../src/mixins/global'
import i18n from './i18n'
Vue.mixin(globalMixin)

import config from '../config.js'

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);
  const loggedUser = localStorage.getItem('oshmiUser')

  if (requiresAuth && !loggedUser) {
    next('/');
  }
  else if (requiresAuth && !config.getToken()) {
    next('/')
  }
  else {
    next();
  }
  
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
